/**
 * @generated SignedSource<<a0706813384a3ae56950b49a09db5eb6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TranslatableTextFieldTranslateButton_textTranslation$data = {
  readonly id: string;
  readonly string: string | null;
  readonly " $fragmentType": "TranslatableTextFieldTranslateButton_textTranslation";
};
export type TranslatableTextFieldTranslateButton_textTranslation$key = {
  readonly " $data"?: TranslatableTextFieldTranslateButton_textTranslation$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranslatableTextFieldTranslateButton_textTranslation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranslatableTextFieldTranslateButton_textTranslation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "string",
      "storageKey": null
    }
  ],
  "type": "TextTranslation",
  "abstractKey": null
};

(node as any).hash = "61eb5fb9324296798c3d70180d09ff6c";

export default node;
